import LandingComponent from './components/landing-component'

function App() {
  return (
    <>
      <LandingComponent />
    </>
  )
}

export default App
